import Icon from '@ant-design/icons';
import { SearchOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { UnixToDate } from '../../../../_config/utils/unix-to-date.util';
import { ColumnTitles } from '../constants/column-titles.constant';
import { statusNames } from '../constants/status-names.constant';

export const generateColumns = () => {
	return [
		{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].operation_id,
			dataIndex: 'operation_id',
			key: 'operation_id',
		},
		{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].trx_id,
			dataIndex: 'trx_id',
			key: 'trx_id',
			render: (trx_id) => trx_id || '--',
		},
		{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].pharmacy,
			dataIndex: 'pharmacy',
			key: 'pharmacy',
		},
		{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].type_document,
			dataIndex: 'type_document',
			key: 'type_document',
			render: () => 'Solicitud de producto',
		},
		{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].status,
			dataIndex: 'status',
			key: 'status',
			render: (status) => statusNames[Enviroment.LANGUAGE][status.status],
		},

		{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].created_at,
			dataIndex: 'created_at',
			key: 'created_at',
			render: (created_at) => UnixToDate(created_at),
		},
		{
			align: 'center',
			title: ColumnTitles[Enviroment.LANGUAGE].detail,
			dataIndex: 'operation_id',
			key: 'operation_id',
			render: (operation_id) => {
				return (
					<Link to={`/v2/reserve/detail/${operation_id}`}>
						<Icon className="link-voucher" component={SearchOutlined} />
					</Link>
				);
			},
		},
	];
};
